import { useCallback } from "react";
import { navigate } from "wouter/use-browser-location";
import { useSearch } from "wouter";

export const spaceHref = (slug: string, viewId?: string) => (viewId ? `/s/${slug}/${viewId}` : `/s/${slug}`);

/** The open item lives in the query string (?item=BW-12), so any page can show it and links can be shared. */
export function useOpenItem(): [string | null, (key: string | null) => void] {
  const search = useSearch();
  const current = new URLSearchParams(search).get("item");
  const set = useCallback((key: string | null) => {
    const params = new URLSearchParams(window.location.search);
    if (key) params.set("item", key);
    else params.delete("item");
    const qs = params.toString();
    navigate(`${window.location.pathname}${qs ? `?${qs}` : ""}`, { replace: !key || Boolean(current) });
  }, [current]);
  return [current, set];
}

export function openItem(key: string) {
  const params = new URLSearchParams(window.location.search);
  params.set("item", key);
  navigate(`${window.location.pathname}?${params}`);
}

export { navigate };
